import { Button, Card, DatePicker, Divider, Flex, Form, Space } from 'antd';
import dayjs from 'dayjs';
import { useDownloadCenter } from '../../contexts/DownloadCenterContext';
import { ScheduleOutlined } from '@ant-design/icons';

const { Meta } = Card;
const { RangePicker } = DatePicker;

const presetButtons = ['Today', 'Last 7 Days', 'Last 30 Days', 'This Month'];

const GlobalDatePreset = () => {
  const [form] = Form.useForm();
  const { setDateRange } = useDownloadCenter();

  const dateRange = Form.useWatch('dateRange', form); // track field value changes

  const onFinish = () => {
    console.log(dateRange);
    setDateRange(dateRange);
  };

  const handlePreset = e => {
    const value = e.target.innerText.toLowerCase();

    switch (value) {
      case 'today':
        form.setFieldsValue({ dateRange: [dayjs(), dayjs()] });
        break;
      case 'last 7 days':
        form.setFieldsValue({ dateRange: [dayjs().subtract(7, 'days'), dayjs()] });
        break;
      case 'last 30 days':
        form.setFieldsValue({ dateRange: [dayjs().subtract(30, 'days'), dayjs()] });
        break;
      case 'this month':
        form.setFieldsValue({ dateRange: [dayjs().startOf('month'), dayjs()] });
        break;
      default:
        break;
    }
  };

  return (
    <section
      style={{
        maxWidth: '1024px',
        margin: '0 auto',
      }}
    >
      <Card>
        <Flex gap="middle" justify="space-between" align="start" wrap>
          <Meta
            title="Global Date Preset"
            description="Applies automatically to all date-sensitive reports below"
          />
          <Space size={[8, 8]} wrap>
            {presetButtons.map((button, index) => (
              <Button key={index} size="small" onClick={e => handlePreset(e)}>
                {button}
              </Button>
            ))}
          </Space>
        </Flex>

        <Divider />

        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Select report date range"
            name="dateRange"
            rules={[{ required: true, message: 'Please select the dates' }]}
          >
            <RangePicker
              size={'large'}
              style={{
                width: '100%',
              }}
            />
          </Form.Item>
          <Button
            style={{
              textWrap: 'wrap',
              minHeight:'40px',
              height: '100%'
            }}
            icon={<ScheduleOutlined />}
            size={'large'}
            htmlType="submit"
            type="primary"
            disabled={!dateRange}
            block
          >
            Apply To All Date Sensitive Reports
          </Button>
        </Form>
      </Card>
    </section>
  );
};

export default GlobalDatePreset;
